import actionTypes from "../../redux/actionTypes";
import { ActionCreator, Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../../redux/initialState";
import ContentfulService from "../../services/contentfulService";
import { Condition } from "./conditionTypes";
import ContentType from "../../services/contentTypes";

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, null, Action<string>>>;

export const fetchEligibilityConditions: AppThunk = () => {
  return async (dispatch: Dispatch): Promise<Action> => {
    try {
      const contentfulService = new ContentfulService();
      const entry: any = await contentfulService.getContentType(ContentType.SERVICE_CONDITION);
      const conditionArr: Condition[] = entry.items.map(
        (item: { sys: { id: string }; fields: { externalName: string; internalName: string; codeId: string } }) => ({
          id: item.sys.id,
          internalName: item.fields.internalName,
          externalName: item.fields.externalName,
          codeId: item.fields.codeId,
        }),
      );
      return dispatch({
        type: actionTypes.LOAD_CONDITION_SUCCESS,
        payload: conditionArr,
        // payload: entry.items.map((item: { sys: { id: string }; fields: { externalName: string } }) => ({
        //   id: item.sys.id,
        //   condition: item.fields.externalName,
        // })),
      });
    } catch (e) {
      return dispatch({
        type: actionTypes.LOAD_CONDITION_ERROR,
        payload: e,
      });
    }
  };
};
